import {cssBlock, cssStyleResponsive} from '../utils/propsUtils';
import {getMediaURL} from '../utils/renderMedia';

/**
 "media": {
      "src": {
        "lg": "/placeholder.jpg"
      },
      "backgroundSize": {
        "lg": "contain",
        "md": "cover"
      },
      "backgroundPosition": {
        "lg": "top"
      },
      "backgroundRepeat": {
        "lg": "no-repeat"
      }
      "parallax": {
        "xs": true
      }
    }
 * */
export const backgroundImageCss = (media, viewport) => {
  let background = '';
  if (media && media.src) {
    background += cssStyleResponsive(viewport, 'background-image', media.src, (value) => `url(${getMediaURL(value)})`);
    if (media.parallax) {
      background += cssBlock(media.parallax,
        `
            background-size: cover;
            background-attachment: fixed;
            background-position: center;
      `);
      return background;
    }
    background += `
       ${cssStyleResponsive(viewport, 'background-size', media.backgroundSize)}
       ${cssStyleResponsive(viewport, 'background-repeat', media.backgroundRepeat)}
       ${cssStyleResponsive(viewport, 'background-position', media.backgroundPosition)}
    `;
  }
  return background;
};


/**
 "background": {
    "color": {
      "lg": "#39B0FF"
    },
    "media": {
      ...
    }
  }
 * */
export const backgroundCss = ({background, viewport}) => {
  const {backgroundColor, media} = background || {};
  return `
     ${cssStyleResponsive(viewport, 'background-color', backgroundColor)}
     ${backgroundImageCss(media, viewport)}
  `;
};
// these sizes are arbitrary and you can set them to whatever you wish

